.s1i8do12{margin-bottom:7px;height:12px;width:var(--s1i8do12-0);background-color:rgb(200, 200, 200);}
